import { render, staticRenderFns } from "./ActivityLogs.vue?vue&type=template&id=2af14b42&scoped=true&"
import script from "./ActivityLogs.vue?vue&type=script&lang=js&"
export * from "./ActivityLogs.vue?vue&type=script&lang=js&"
import style0 from "./ActivityLogs.vue?vue&type=style&index=0&id=2af14b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af14b42",
  null
  
)

export default component.exports